const dialCodes = {
  zw: '+263',
  zm: '+260',
  ye: '+967',
  wf: '+681',
  vi: '+1340',
  vg: '+1284',
  vn: '+84',
  ve: '+58',
  vu: '+678',
  uz: '+998',
  uy: '+598',
  us: '+1',
  gb: '+44',
  ae: '+971',
  ua: '+380',
  ug: '+256',
  tv: '+688',
  tc: '+1649',
  tm: '+993',
  tr: '+90',
  tn: '+216',
  tt: '+1868',
  to: '+676',
  tk: '+690',
  tg: '+228',
  tl: '+670',
  th: '+66',
  tz: '+255',
  tj: '+992',
  tw: '+886',
  sy: '+963',
  ch: '+41',
  se: '+46',
  sz: '+268',
  sj: '+47',
  sr: '+597',
  sd: '+249',
  lk: '+94',
  es: '+34',
  gs: '+500',
  ss: '+211',
  za: '+27',
  so: '+252',
  sb: '+677',
  si: '+386',
  sk: '+421',
  sg: '+65',
  sl: '+232',
  sc: '+248',
  rs: '+381',
  sn: '+221',
  sa: '+966',
  st: '+239',
  sm: '+378',
  ws: '+685',
  vc: '+1784',
  pm: '+508',
  mf: '+590',
  lc: '+1758',
  kn: '+1869',
  sh: '+290',
  bl: '+590',
  re: '+262',
  rw: '+250',
  ru: '+7',
  ro: '+40',
  qa: '+974',
  pr: '+1939',
  pt: '+351',
  pl: '+48',
  pn: '+872',
  ph: '+63',
  pe: '+51',
  py: '+595',
  pg: '+675',
  pa: '+507',
  ps: '+970',
  pw: '+680',
  pk: '+92',
  om: '+968',
  no: '+47',
  mp: '+1670',
  nf: '+672',
  nu: '+683',
  ng: '+234',
  ne: '+227',
  ni: '+505',
  nz: '+64',
  nc: '+687',
  nl: '+31',
  np: '+977',
  nr: '+674',
  na: '+264',
  mm: '+95',
  mz: '+258',
  ma: '+212',
  ms: '+1664',
  me: '+382',
  mn: '+976',
  mc: '+377',
  md: '+373',
  fm: '+691',
  mx: '+52',
  yt: '+262',
  mu: '+230',
  mr: '+222',
  mq: '+596',
  mh: '+692',
  mt: '+356',
  ml: '+223',
  mv: '+960',
  my: '+60',
  mw: '+265',
  mg: '+261',
  mk: '+389',
  mo: '+853',
  lu: '+352',
  lt: '+370',
  li: '+423',
  ly: '+218',
  lr: '+231',
  ls: '+266',
  lb: '+961',
  lv: '+371',
  la: '+856',
  kg: '+996',
  kw: '+965',
  kr: '+82',
  kp: '+850',
  ki: '+686',
  ke: '+254',
  kz: '+77',
  jo: '+962',
  je: '+44',
  jp: '+81',
  jm: '+1876',
  it: '+39',
  il: '+972',
  im: '+44',
  ie: '+353',
  iq: '+964',
  ir: '+98',
  id: '+62',
  in: '+91',
  is: '+354',
  hu: '+36',
  hk: '+852',
  hn: '+504',
  va: '+379',
  ht: '+509',
  gy: '+595',
  gw: '+245',
  gn: '+224',
  gg: '+44',
  gt: '+502',
  gu: '+1671',
  gp: '+590',
  gd: '+1473',
  gl: '+299',
  gr: '+30',
  gi: '+350',
  gh: '+233',
  de: '+49',
  ge: '+995',
  gm: '+220',
  ga: '+241',
  pf: '+689',
  gf: '+594',
  fr: '+33',
  fi: '+358',
  fj: '+679',
  fo: '+298',
  fk: '+500',
  et: '+251',
  ee: '+372',
  er: '+291',
  gq: '+240',
  sv: '+503',
  eg: '+20',
  ec: '+593',
  do: '+1849',
  dm: '+1767',
  dj: '+253',
  dk: '+45',
  cz: '+420',
  cy: '+357',
  cu: '+53',
  hr: '+385',
  ci: '+225',
  cr: '+506',
  ck: '+682',
  cd: '+243',
  cg: '+242',
  km: '+269',
  co: '+57',
  cc: '+61',
  cx: '+61',
  cn: '+86',
  cl: '+56',
  td: '+235',
  cf: '+236',
  ky: '+ 345',
  cv: '+238',
  ca: '+1',
  cm: '+237',
  kh: '+855',
  bi: '+257',
  bf: '+226',
  bg: '+359',
  bn: '+673',
  io: '+246',
  br: '+55',
  bw: '+267',
  ba: '+387',
  bo: '+591',
  bt: '+975',
  bm: '+1441',
  bj: '+229',
  bz: '+501',
  be: '+32',
  by: '+375',
  bb: '+1246',
  bd: '+880',
  bh: '+973',
  bs: '+1242',
  az: '+994',
  at: '+43',
  au: '+61',
  aw: '+297',
  am: '+374',
  ar: '+54',
  ag: '+1268',
  aq: '+672',
  ai: '+1264',
  ao: '+244',
  ad: '+376',
  as: '+1684',
  dz: '+213',
  al: '+355',
  ax: '+358',
  af: '+93',
}

const isCountryCode = (code: string): code is CountryCode => {
  return Object.hasOwnProperty.call(dialCodes, code)
}

export type CountryCode = keyof typeof dialCodes
export const dialCodeForCountry = (countryCode: string): string | undefined => {
  if (isCountryCode(countryCode)) {
    return dialCodes[countryCode]
  }
}
